import React, { useState } from 'react';

interface StartVotingFormProps {
  onStart: (storyTitle: string, storyDescription: string) => void;
}

/** Moderator-only form that opens a new voting session. */
const StartVotingForm: React.FC<StartVotingFormProps> = ({ onStart }) => {
  const [storyTitle, setStoryTitle] = useState('');
  const [storyDescription, setStoryDescription] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!storyTitle.trim()) return;

    onStart(storyTitle, storyDescription);
    setStoryTitle('');
    setStoryDescription('');
  };

  return (
    <div className="voting-control card">
      <h3>新しい投票セッションを開始</h3>
      <form onSubmit={handleSubmit} className="voting-form">
        <div className="form-group">
          <label htmlFor="storyTitle">ストーリータイトル:</label>
          <input
            type="text"
            id="storyTitle"
            value={storyTitle}
            onChange={(e) => setStoryTitle(e.target.value)}
            required
            className="form-input"
            placeholder="例: ユーザー認証機能の実装"
          />
        </div>
        <div className="form-group">
          <label htmlFor="storyDescription">説明 (オプション):</label>
          <textarea
            id="storyDescription"
            value={storyDescription}
            onChange={(e) => setStoryDescription(e.target.value)}
            className="form-textarea"
            placeholder="ストーリーの詳細説明..."
            rows={3}
          />
        </div>
        <button type="submit" className="btn btn-primary">
          投票を開始
        </button>
      </form>
    </div>
  );
};

export default StartVotingForm;
